import React from "react";
import { useNavigate } from "react-router-dom";

const AUTH_KEYS = ["AccessToken", "RefreshToken", "CurrentAuthToken", "AuthToken", "userId", "userName", "UserInfo", "LogId"];

export default function SessionExpiredPage() {
  const navigate = useNavigate();
  const message =
    sessionStorage.getItem("sessionExpiredMessage") ||
    "Your session is invalid or has expired. Please login again to continue.";

  const goToLogin = () => {
    AUTH_KEYS.forEach((key) => {
      sessionStorage.removeItem(key);
      localStorage.removeItem(key);
    });
    sessionStorage.removeItem("sessionExpiredMessage");
    navigate("/login", { replace: true });
  };

  return (
    <div className="relative flex h-screen w-screen items-center justify-center px-4">
      <div
        className="absolute inset-0"
        style={{
          background: "linear-gradient(135deg, var(--base-200), var(--base-100))",
        }}
      />

      <div className="glass-card relative z-10 w-full max-w-md px-6 py-8 text-center animate-fade-in">
        <div
          className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full text-2xl font-bold"
          style={{
            background: "rgba(220, 38, 38, 0.12)",
            color: "#dc2626",
          }}
        >
          !
        </div>

        <h1
          className="mb-3 text-2xl font-bold"
          style={{
            background: "linear-gradient(135deg, var(--primary), var(--primary-focus))",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Session Expired
        </h1>

        <p className="mb-6 text-sm leading-6 text-gray-700">{message}</p>

        <button onClick={goToLogin} className="btn-professional h-11 w-full">
          Go to Login
        </button>
      </div>
    </div>
  );
}
